import Footer from "Components/Common/Footer/Footer";
import HeaderWithoutMenu from "Components/Common/Header/HeaderWithoutMenu";
import EventDetailsBody from "Components/EventDetails/EventDetailsBody/EventDetailsBody";

const EventDetails = () => {
  return (
    <>
      <HeaderWithoutMenu />
      <EventDetailsBody />
      <Footer />
    </>
  );
};

export default EventDetails;
